import { canonicalBytes } from "./canonical.js";
import { concatBytes, utf8 } from "./encoding.js";
export function followSigningPayload(intent) {
    return concatBytes(utf8("vox.follow.signature.v1"), new Uint8Array([0]), canonicalBytes(intent));
}
export function followViewerSigningPayload(input) {
    return concatBytes(utf8("vox.follow.viewer.signature.v1"), new Uint8Array([0]), canonicalBytes(input));
}
//# sourceMappingURL=follow.js.map